import { cn } from '@/utils';
import Image from 'next/image';

export default function PercentagePill(props: { percentage: number; className?: string }) {
  return (
    <div className={cn('bg-surface p-1 px-2 shadow rounded-full flex items-center', props.className)}>
      <div className="flex items-center gap-1">
        <Image
          className="w-4"
          src={props.percentage === 100 ? '/images/complete-full.svg' : '/images/incomplete.svg'}
          alt={props.percentage === 100 ? 'Tick' : 'Clock'}
          width={16}
          height={16}
        />
        <span className="text-sm weight-600 hover:text-primary">{`${props.percentage}%`}</span>
      </div>
    </div>
  );
}
